export const PLAYER_ID_COOKIE = "playerId";
export const GAME_ID_COOKIE = "gameId";
